function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { objectAssign } from 'meteora';
var VideoEmbed = /*#__PURE__*/function () {
  function VideoEmbed(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, VideoEmbed);
    this.video = this.parseURL(url);
    this.options = objectAssign({
      attributes: ["frameborder=\"0\"", "allow=\"autoplay; encrypted-media\"", "allowfullscreen", "mozallowfullscreen", "webkitallowfullscreen"],
      modestbranding: 1,
      autoplay: 1,
      rel: 0
    }, options);
  }
  _createClass(VideoEmbed, [{
    key: "parseURL",
    value: function parseURL(url) {
      url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
      return {
        type: RegExp.$3.indexOf('youtu') > -1 ? 'youtube' : 'vimeo',
        id: RegExp.$6
      };
    }
  }, {
    key: "render",
    value: function render() {
      var src = this.video.type === 'youtube' ? "https://www.youtube.com/embed/".concat(this.video.id, "?") : "https://player.vimeo.com/video/".concat(this.video.id, "?");
      for (var key in this.options) {
        if (_typeof(this.options[key]) !== 'object') {
          if (this.options[key] === 1 && key === 'loop') src += "playlist=".concat(this.video.id, "&");
          src += "".concat(key, "=").concat(this.options[key], "&");
        }
      }
      return "<iframe class=\"js-".concat(this.video.type, "-embed\" src = \"").concat(src, "\" ").concat(this.options.attributes.join(' '), "> ");
    }
  }]);
  return VideoEmbed;
}();
export default VideoEmbed;

// let videoEmbed = new Embed('https://www.youtube.com/watch?v=dbB-mICjkQM', { autoplay: 0 });

// $body.append(videoEmbed.render());